import React, { useEffect } from 'react'
import { getSession, useSession } from 'next-auth/react'
import { useRouter } from 'next/router'
import { RiLoaderFill } from 'react-icons/ri'

interface IProps {
  children: React.ReactNode
}

// TODO: handle as middleware?
const AuthGuard: React.FC<IProps> = ({ children }) => {
  const { data: session, status } = useSession()
  const router = useRouter()
  useEffect(() => {
    if (status === 'loading') {
      return
    }

    if (status !== 'authenticated') {
      router.push('/account/login')
    }
  }, [status, router])

  if (session) {
    return children as any
  }

  return (
    <div className={'text-center'}>
      <RiLoaderFill className={'loader mx-auto text-4xl'} />
    </div>
  )
}

export default AuthGuard
